import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  frontPropertyDetail,
  frontPreBookingDetail,
} from "../../../Services/BON-Frontend/Service";

export const getPropertyDetail = createAsyncThunk(
  "property/getPropertyDetail",
  async (pid, { rejectWithValue }) => {
    try {
      const response = await frontPropertyDetail(pid);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getRoomDetails = createAsyncThunk(
  "property/getRoomDetails",
  async ({ PropertyID, CheckIn, CheckOut }, { rejectWithValue }) => {
    try {
      const response = await frontPreBookingDetail(
        PropertyID,
        CheckIn,
        CheckOut
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const propertySlice = createSlice({
  name: "property",
  initialState: {
    propertyDetails: null,
    roomDetails: [],
    bookingDetails: null,
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder

      // Property Detail
      .addCase(getPropertyDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPropertyDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.propertyDetails =
          action.payload?.PropertyDetails?.[0] || null;
      })
      .addCase(getPropertyDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Room Detail
      .addCase(getRoomDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRoomDetails.fulfilled, (state, action) => {
        state.loading = false;

        state.roomDetails = action.payload?.RatePlan || [];

        state.bookingDetails =
          action.payload?.RoomDetails?.[0] || null;
      })
      .addCase(getRoomDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default propertySlice.reducer;